export default __webpack_public_path__ + "static/media/backgroundimage.7d6ac6e8.png";